import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { getInvertColor } from "utils/themeUtils";

export const SubmitButton = styled(Button)(({ theme }) => ({
	padding: "0.5rem 1rem",
	color: getInvertColor(theme.palette.primary.main),
	backgroundColor: theme.palette.primary.main,
	"&:hover": {
		backgroundColor: theme.palette.primary.main,
	},
	[theme.breakpoints.down("mobile")]: {
		backgroundColor: "transparent",
		color: "transparent",
		padding: 0,
		position: "absolute",
		right: "0%",
		top: "25%",
		"&:hover": {
			backgroundColor: "transparent",
		},
	},
	[theme.breakpoints.up("xl")]: {
		marginTop: "1.25rem",
	},
}));

export const CommentText = styled(TextField)(({ theme }) => ({
	color: theme.palette.common.white,
	"& .MuiInputBase-formControl": {
		padding: "0.75rem",
		[theme.breakpoints.up("lg")]: {
			padding: "1rem",
		},
	},
}));

export const Container = styled(Card)(({ theme }) => ({
	width: "100%",
	padding: "1rem 1.5rem",
	boxShadow: "0px 15px 40px #77777729",
	background: "#FFFFFF 0% 0% no-repeat padding-box",
	borderRadius: "5px",
	opacity: 1,
	gridArea: "rating-comment",
	color: theme.typography.h2.color,
}));

export const Fieldset = styled(Box)(({ theme }) => ({
	padding: 0,
	border: 0,
	margin: 0,
}));

export const Title = styled(Typography)(({ theme }) => ({
	color: theme.typography.h1.color,
	fontSize: "0.75rem",
	fontWeight: 700,
	padding: "0.5rem 0",
	[theme.breakpoints.down("mobile")]: {
		fontSize: 14,
	},
	[theme.breakpoints.up("lg")]: {
		fontSize: "1.25rem",
		fontWeight: 700,
	},
	[theme.breakpoints.up("xl")]: {
		padding: "1rem 0",
		fontSize: "1.5rem",
		fontWeight: 700,
	},
}));

export const RatingSystemCommentTitle = styled(Typography)(({ theme }) => ({
	color: theme.typography.h2.color,
	fontSize: "1rem",
	fontWeight: 700,
	padding: "0.5rem 0",
	[theme.breakpoints.up("lg")]: {
		padding: "0.75rem 0",
		fontSize: "1rem",
		fontWeight: 700,
	},
	[theme.breakpoints.up("xl")]: {
		padding: "1rem 0 0.75rem 0",
		fontSize: "1.25rem",
		fontWeight: 700,
	},
}));
